<template>
  <div class="p-0 m-0">


    <div class="container">
      <div class="row">

        <m-filter-feature-2 :filterRoute="filterRoute" :features-id="filterFeaturesId"/>

        <div class="col-lg-12 archive-items col-sm-12">


          <div class="row">
            <div :class="cardWrapperCLass" v-for="product in products">

              <m-a v-if="cardLink" :href="{ name: 'Product', params: { name: product.raw_link } }"
                   :target="cardLinkTarget">
                <component :is="productCardNameComputed" :class="cardCLass"
                           :offer-status="offerStatus" :offerType="offerType"
                           :product="product"/>
              </m-a>
              <component v-else :is="productCardNameComputed" :class="cardCLass"
                         :offer-status="offerStatus" :offerType="offerType"
                         :product="product"/>

            </div>

            <div class="w-100 " id="products-card-skeleton-section"></div>


          </div>

          <div class="row pt-3 mt-3">
            <m-paginate1 :meta="pagination"
                         :on-change-page="loadProducts"/>
          </div>


        </div>


      </div>
    </div>
  </div>
</template>

<script>
import mProductWrapper from "../../../Wrappers/ProductWrapper";
import mPaginate1 from "../../../Pagination/Paginate1";
import mFilterBrand1 from "../../../Brand/Filter/FilterBrand1";
import mFilterSearch1 from "../../../Search/Filter/FilterSearch1";
import mFilterQuantity1 from "../../../Product/QuantityManager/Filter/FilterQuantity1";
import mFilterFeature1 from "../../../Feature/Filter/FilterFeature1";
import mFilterCategory1 from "../../../Category/Filter/FilterCategory1/FilterCategory1";
import mFilterMultipleStore1 from "../../../MultipleStore/Filter/FilterMultipleStore1";
import mSortPriceFilter from "../../../Sort/Filter/SortPriceFilter";
import {Cards} from "../../Card/Cards";
import {OfferProps} from '../../../Product/ProductOffer/ProductOfferProps'
import mIcon from "../../../Icons/Icon.vue";
import mA from "../../../Tags/A.vue";
import mCategoriesSlider308 from "../../../Category/Slider/CategoriesSlider308.vue";
import FilterPrice from "../../Filter/FilterPrice.vue";
import SkeletonWrapper from "../../../Wrappers/SkeletonWrapper.vue";
import {ProductArchiveSkeleton} from "../../Skeleton/Archive/ProductArchiveSkeleton";
import {isNumber} from "lodash";
import FilterCategory2 from "../../../Category/Filter/FilterCategory2/FilterCategory2.vue";
import mFilterFeature2 from "../../../Feature/Filter/FilterFeature2/FilterFeature2.vue";

export default {
  name: "Products3",
  components: {
    FilterCategory2,
    SkeletonWrapper,
    FilterPrice,
    mA, mIcon,
    ...Cards,
    ...ProductArchiveSkeleton,
    mProductWrapper,
    mPaginate1,
    mFilterBrand1,
    mFilterSearch1,
    mFilterQuantity1,
    mFilterFeature1,
    mFilterCategory1,
    mFilterMultipleStore1,
    mSortPriceFilter,
    mCategoriesSlider308,
    mFilterFeature2,
  },
  props: {
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    },
    cardCLass: {
      default: 'my-1'
    },
    cardWrapperCLass: {
      default: 'col-lg-4 archive-parent-item'
    },
    ...OfferProps,
    cardLink: {
      type: Boolean,
      default: true
    },
    cardLinkTarget: {
      options: ['_self', '_blank'],
      default: '_self',
    },
    feature_name: {
      default: null
    },
    filterFeaturesId: {
      default: [],
      type: Object,
    },
    filterRoute: {
      default: 'Product',
    },
  },
  data() {
    return {
      screenSizeName: 'lg',
      products: [],
      pagination: {},
    }
  },
  computed: {
    productCardNameComputed() {
      if (this.screenSizeName === 'sm') {
        return this.smCardName
      }

      return this.productCardName
    }
  },
  methods: {
    async loadProducts(page = 1) {
      let form = {
        page: page,
        feature_name: this.feature_name,
      }
      let req = await this.$store.dispatch('Product/findNearestProduct', form)
      let data = req.data.data
      this.products = data.data
      this.pagination = data.meta
    },
    setProductFeatureFromQuery() {
      let features = this.$route.query.features;

      if (features != '' && features != undefined) {
        this.$store.commit("Product/setFilters", {key: "feature", value: features.split(',')});
      }

      return true
    },
  },
  beforeMount() {
    this.setProductFeatureFromQuery()
  },
  mounted() {
    this.loadProducts()
  }

}
</script>

<style scoped>
</style>